import { render, staticRenderFns } from "./VH5BadgeOnly.vue?vue&type=template&id=48b7ba62&scoped=true"
import script from "./VH5BadgeOnly.vue?vue&type=script&lang=js"
export * from "./VH5BadgeOnly.vue?vue&type=script&lang=js"
import style0 from "./VH5BadgeOnly.vue?vue&type=style&index=0&id=48b7ba62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b7ba62",
  null
  
)

export default component.exports